import {put, select} from "redux-saga/effects";
import {GroupObject} from "../../../../../vkapi/objects/GroupObject";
import {Topic} from "../../../../../vkapi/objects/Topic";
import {convert_urls_to_id, TopicAddress} from "../../../../../vkapi/tasks/ConverUrlToId";
import GetBoardTopics from "../../../../../vkapi/tasks/GetBoardTopics";
import GetGroups from "../../../../../vkapi/tasks/GetGroups";
import {RootState} from "../../../types";
import * as actions from "../actions";
import {TopicsParserState} from "../types";

const main = function* () {
    const state: TopicsParserState = yield select((state: RootState) => state.topicsParser);
    const access_token = yield select((state: RootState) => state.app.access_token);

    const group_urls: string[] = convert_urls_to_id(state.settings.links_groups.split('\n'));
    const groups: GroupObject[] = yield GetGroups({
        access_token: access_token,
        group_ids: group_urls,
        add_api_errors_action: actions.addApiError,
        progress_action: actions.setProgress,
    });

    const topic_addresses: TopicAddress[] = groups.map((group: GroupObject) => {
        return {
            owner_id: group.id,
        }
    });

    const topics: Topic[] = yield GetBoardTopics({
        topic_addresses: topic_addresses,
        access_token: access_token,
        add_api_errors_action: actions.addApiError,
        progress_action: actions.setProgress,
    });

    yield put(actions.setResult({
        user_ids: [],
        topics: topics,
        comments: [],
    }));
};

export default main;
